import { FirstTutorialLayer } from './../../FirstTutorialLayer';
import { BattleScene } from './../../BattleScene';
import { BoardContainer } from './../../board-container/BoardContainer';
import { SelectTurretMenu } from "./SelectTurretMenu";
import { BattleManager } from "../../BattleManager";
import { GameVars } from "../../../../GameVars";
import { AudioManager } from "../../../../AudioManager";

export class SelectTurretButton extends Phaser.GameObjects.Container {

    private selectTurretMenu: SelectTurretMenu;
    private firstTutorialLayer: FirstTutorialLayer;
    private i: number;
    private key: string;

    private turret: Phaser.GameObjects.Image;
    private txtPrice: Phaser.GameObjects.Text;
    private unlocked: Phaser.GameObjects.Image;

    constructor(scene: Phaser.Scene, x: number, y: number, i: number, selectTurretMenu?: SelectTurretMenu, firstTutorialLayer?: FirstTutorialLayer) {

        super(scene);

        this.x = x;
        this.y = y;

        this.i = i;

        this.selectTurretMenu = selectTurretMenu;
        this.firstTutorialLayer = firstTutorialLayer;

        let turretKeys = Object.keys(GameVars.turretsData);

        this.key = turretKeys[i];

        this.turret = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "build_" + (i + 1));
        this.turret.setInteractive();
        this.turret.on("pointerup", () => { this.onClickTurret(); });
        this.add(this.turret);

        this.txtPrice = new Phaser.GameObjects.Text(this.scene, 0, 20, GameVars.turretsData[this.key].price, {fontFamily: "Rubik-Bold", fontSize: "18px", color: "#ffffff", align: "center"});
        this.txtPrice.setOrigin(.5);
        this.txtPrice.setStroke("#000000", 4);
        this.add(this.txtPrice);

        this.unlocked = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "btn_locked");
        this.add(this.unlocked);

        this.scene.sys.updateList.add(this);
    }

    public preUpdate(time: number, delta: number): void {

        if (GameVars.gameData.upgradesUnlocked[this.key] === 0) {
            this.unlocked.visible = true;
            this.turret.alpha = .75;
            this.turret.tint = 0x555555;
            this.txtPrice.visible = false;
        } else if (GameVars.turretsData[this.key].price > BattleManager.anutoEngine.credits) {
            this.unlocked.visible = false;
            this.turret.alpha = .75;
            this.turret.tint = 0x555555;
        } else {
            this.unlocked.visible = false;
            this.turret.alpha = 1;
            this.turret.tint = 0xFFFFFF;
        }
    }

    private onClickTurret(): void {

        if (GameVars.gameData.upgradesUnlocked[this.key] === 0 || GameVars.turretsData[this.key].price > BattleManager.anutoEngine.credits) {
            return;
        }

        AudioManager.playSound("build_tower");

        if (this.selectTurretMenu) {
            BattleManager.addTurretToScene(this.key, {r: this.selectTurretMenu.flagPosition.r, c: this.selectTurretMenu.flagPosition.c});
        } else {
            BattleManager.addTurretToScene(this.key, {r: 6, c: 5});
            this.firstTutorialLayer.hideButtons();
        }
    }
}
